// Images
import IwantClips from '../../assets/images/logos/i-want-clips-logo.png';
import Clips4Sale from '../../assets/images/logos/clips4sale-logo.png';
import ManyVids from '../../assets/images/logos/manyvids-banner.jpg';
import LoyalFans from '../../assets/images/logos/loyalfans-banner.png';
import OnlyFans from '../../assets/images/logos/onlyfans-logo-no-background.png';
import MyFet from '../../assets/images/logos/myfet-banner.png';
import Dominity from '../../assets/images/logos/dominity-banner.png';
import FinMessage from '../../assets/images/logos/finmessage-banner.jpg';
import Fetlife from '../../assets/images/logos/fetlife-banner.png';
// Constants
import { FETLIFE_URL, MANYVIDS_URL, ONLYFANS_URL } from '../Constants';

export const externalLinksArray = [
  {
    title: 'ManyVids (MV)',
    image: ManyVids,
    url: MANYVIDS_URL,
    alt: 'ManyVids - Sammi Smith',
  },
  {
    title: 'OnlyFans (OF)',
    image: OnlyFans,
    url: ONLYFANS_URL,
    alt: 'OnlyFans - Sammi Smith',
  },
  {
    title: 'FetLife',
    image: Fetlife,
    url: FETLIFE_URL,
    alt: 'FetLife - Sammi Smith',
  },
];
